module.exports = __webpack_public_path__ + "img/intract_logo.85ee001e.png";